var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade-page"}},[(_vm.isLoading)?_c('div',{staticClass:"space-loading",style:({'backgroundColor': _vm.bgColor})},[_c('CircleLoader',{attrs:{"width":4,"color":_vm.color}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }